/*
 *   File : login.js
 *   Author : https://evoqins.com
 *   Description :Login page of raayi
 *   Integrations : 'js-cookie , react-toastify'
 *   Version : 1.0.0
*/

// custom packages
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

// custom components
import { CustomTextInput } from '../../Components/FormElements';
import { PrimaryButton } from "../../Components/Buttons";
import { APIService } from '../../Service';

// custom style 
import style from "../../Style/Component/auth.module.scss";

const SetPassword = () => {

    const navigate = useNavigate();

    const [email, setEmail] = useState("");
    const [emailError, setEmailError] = useState("");

    const [otp, setOtp] = useState("");
    const [otpError, setOtpError] = useState("");

    const [newPassword, setNewPassword] = useState("");
    const [newPasswordError, setNewPasswordError] = useState("");

    const [confirmNewPassword, setConfirmNewPassword] = useState("");
    const [confirmNewPasswordError, setConfirmNewPasswordError] = useState("");

    useEffect(() => {
        setEmailError("");
    }, [email]);

    useEffect(() => {
        setOtpError("");
    }, [otp]);

    useEffect(() => {
        setNewPasswordError("");
    }, [newPassword]);

    useEffect(() => {
        setConfirmNewPasswordError("");
    }, [confirmNewPassword]);

    // handle verify otp
    const _handleConfirm = () => {
        let is_valid = true;
        let validate_email = /^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]+$/;
        let validate_new_password = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

        if (email.trim().length === 0) {
            setEmailError("Enter your email address");
            is_valid = false;
        } else if (!validate_email.test(email)) {
            setEmailError("Enter a valid email address");
            is_valid = false;
        }
        if (otp.length < 4) {
            setOtpError("Please enter received OTP");
            is_valid = false;
        }
        if (newPassword.trim().length === 0) {
            setNewPasswordError("Please provide new password");
        } else if (!validate_new_password.test(newPassword)) {
            setNewPasswordError("Please provide a valid password");
            is_valid = false
        }
        if (confirmNewPassword.trim().length === 0) {
            setConfirmNewPasswordError("Re-enter the password");
        } else if (newPassword !== confirmNewPassword) {
            setConfirmNewPasswordError("Password do not match");
            is_valid = false
        }
        if (is_valid === true) {
            _setPassword();
        }
    };


    // API - set password
    const _setPassword = () => {
        let is_post = true;
        let url = 'auth/set-password';
        let request = {
            "email": email,
            "otp": otp,
            "password": confirmNewPassword
        }
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                navigate('/login');
            } else {
                toast.dismiss();
                toast.error(response.message, { type: "error" });
            }
        })
    };

    return (
        <section className={`${style.e_auth_wrapper} padding-64px-tb`}>
            <div className='container px-lg-0 px-md-0 px-sm-0 px-3'>
                <div className='text-center'>
                    <img src={require("../../Assets/Image/logo.svg").default}
                        draggable={false}
                        className='user-select-none'
                        alt='rayi-logo' />
                </div>
                <div className='row padding-32px-top'>
                    <div className='offset-lg-4 offset-md-2 offset-sm-2 offset-1 col-lg-4 col-md-8 col-sm-8 col-10 px-lg-0'>
                        <div className={`${style.e_form_wrapper} e-bg-white border-radius-16 padding-40px-all`}>
                            <>
                                <h3 className='mb-4 e-text-chinese-black e-primary-font e-font-24 e-font-weight-700 line-height-28px'>
                                    Set Password
                                </h3>

                                <div className="col-12 pb-4">
                                    <CustomTextInput label="Enter registered email"
                                        placeholder="Enter email"
                                        type="text"
                                        autoFocus={true}
                                        required={true}
                                        value={email}
                                        error={emailError}
                                        className="w-100"
                                        onKeyPress={_handleConfirm}
                                        handleChange={(e) => setEmail(e)} />
                                </div>

                                {/* Otp */}
                                <div className="col-12 pb-4">
                                    <CustomTextInput label="Enter the OTP"
                                        placeholder="Enter The OTP"
                                        type="text"
                                        autoFocus={false}
                                        required={true}
                                        value={otp}
                                        error={otpError}
                                        className="w-100"
                                        onKeyPress={_handleConfirm}
                                        handleChange={(e) => setOtp(e)} />
                                </div>

                                {/* New Password */}
                                <div className='col-12 pb-4'>
                                    <CustomTextInput label="New password"
                                        placeholder="Enter New password"
                                        type="password"
                                        autoFocus={false}
                                        required={true}
                                        value={newPassword}
                                        showIcon={true}
                                        error={newPasswordError}
                                        className="w-100"
                                        inputType={1}
                                        onKeyPress={_handleConfirm}
                                        handleChange={(e) => setNewPassword(e)} />
                                </div>

                                {/* Confirm New Password */}
                                <div className='col-12 pb-5'>
                                    <CustomTextInput label="Confirm new password"
                                        placeholder="Confirm new password"
                                        type="password"
                                        autoFocus={false}
                                        required={true}
                                        showIcon={true}
                                        value={confirmNewPassword}
                                        error={confirmNewPasswordError}
                                        className="w-100"
                                        inputType={1}
                                        onKeyPress={_handleConfirm}
                                        handleChange={(e) => setConfirmNewPassword(e)} />
                                </div>

                                {/* Confirm button */}
                                <PrimaryButton name="Confirm"
                                    className="w-100"
                                    onClick={_handleConfirm} />
                            </>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default SetPassword;
